import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { mainReducer } from "./reducers";

const composeEnhancers = composeWithDevTools({
  // Specify here name, actionsBlacklist, actionsCreators and other options
});

const store = createStore(
  mainReducer,
  composeEnhancers()
  // applyMiddleware(...middleware)
  // other store enhancers if any
);

export default store;
